import { Routes } from '@angular/router';
import { farmaciaGuard } from '../../core/guards/farmacia.guard';

export const farmaciaRoutes: Routes = [
  {
    path: 'farmacia',
    canActivate: [farmaciaGuard],
    loadComponent: () => import('./layout/layout.component').then(m => m.FarmaciaLayoutComponent),
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('./dashboard/dashboard.component').then(m => m.DashboardComponent)
      },
      {
        path: 'perfil',
        loadComponent: () => import('./perfil/perfil.component').then(m => m.PerfilComponent)
      },
      {
        path: 'medicamentos',
        loadComponent: () => import('./medicamentos/medicamentos.component').then(m => m.MedicamentosComponent)
      },
      {
        path: 'estoque',
        loadComponent: () => import('./estoque/estoque.component').then(m => m.EstoqueComponent)
      },
      {
        path: 'funcionarios',
        loadComponent: () => import('./funcionarios/funcionarios.component').then(m => m.FuncionariosComponent)
      },
      {
        path: 'receituarios',
        loadComponent: () => import('./receituarios/receituarios.component').then(m => m.ReceituariosComponent)
      },
      {
        path: 'relatorios',
        loadComponent: () => import('./relatorios/relatorios.component').then(m => m.RelatoriosComponent)
      },
      {
        path: 'suporte',
        loadComponent: () => import('./suporte/suporte.component').then(m => m.SuporteComponent)
      },
      {
        path: 'suporte/ticket/:id',
        loadComponent: () => import('./suporte/ticket-detalhes/ticket-detalhes.component').then(m => m.TicketDetalhesComponent)
      },
      {
        path: 'notificacoes',
        loadComponent: () => import('./notificacoes/notificacoes.component').then(m => m.NotificacoesComponent)
      },
      {
        path: 'pedidos',
        loadComponent: () => import('./pedidos/pedidos.component').then(m => m.PedidosComponent)
      },
      {
        path: 'assinatura',
        loadComponent: () => import('./assinatura/assinatura.component').then(m => m.AssinaturaComponent)
      },
      {
        path: 'clientes',
        loadComponent: () => import('./clientes/clientes.component').then(m => m.ClientesComponent)
      },
      {
        path: 'vendas',
        loadComponent: () => import('./vendas/vendas.component').then(m => m.VendasComponent)
      },
      {
        path: 'fornecedores',
        loadComponent: () => import('./fornecedores/fornecedores.component').then(m => m.FornecedoresComponent)
      },
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      }
    ]
  }
];
